// Tax deduction rules for business expenses

export interface TaxRule {
  category: string;
  deductionRate: number; // 0-100%
  description: string;
}

export const TAX_RULES: TaxRule[] = [
  {
    category: "Meals & entertainment",
    deductionRate: 50,
    description: "Business meals are 50% deductible"
  },
  {
    category: "Vehicle expenses",
    deductionRate: 100,
    description: "Gas and vehicle maintenance are 100% deductible"
  },
  {
    category: "Tools",
    deductionRate: 100,
    description: "Professional tools are 100% deductible"
  },
  {
    category: "Office supplies",
    deductionRate: 100,
    description: "Office supplies are 100% deductible"
  },
  {
    category: "Travel",
    deductionRate: 100,
    description: "Business travel expenses are 100% deductible"
  },
  {
    category: "Home office",
    deductionRate: 100,
    description: "Home office expenses are 100% deductible"
  },
  {
    category: "Repairs",
    deductionRate: 100,
    description: "Business equipment repairs are 100% deductible"
  },
  {
    category: "Inventory",
    deductionRate: 100,
    description: "Inventory purchases are 100% deductible"
  },
  {
    category: "Software",
    deductionRate: 100,
    description: "Software subscriptions are 100% deductible"
  }
];

export const NON_DEDUCTIBLE_CATEGORIES = [
  "Groceries",
  "Personal",
  "Entertainment (personal)",
  "Clothing (personal)"
];

export function getDeductionRate(category: string, customMealRate?: number): number {
  const normalizedCategory = category.toLowerCase().trim();
  
  // Check if it's a non-deductible category
  if (NON_DEDUCTIBLE_CATEGORIES.some(cat => normalizedCategory.includes(cat.toLowerCase()))) {
    return 0;
  }
  
  // Find matching rule
  const rule = TAX_RULES.find(r => normalizedCategory.includes(r.category.toLowerCase()));
  
  // Special case for meals - use custom rate if provided
  if (rule?.category === "Meals & entertainment" && customMealRate !== undefined) {
    return customMealRate;
  }
  
  return rule?.deductionRate || 0;
}

export function calculateTaxSavings(
  amount: number,
  category: string,
  taxRate: number,
  customMealRate?: number
): number {
  const deductionRate = getDeductionRate(category, customMealRate);
  const deductibleAmount = amount * (deductionRate / 100);
  return deductibleAmount * (taxRate / 100);
}

export function isBusinessExpense(category: string): boolean {
  const deductionRate = getDeductionRate(category);
  return deductionRate > 0;
}
